import { render, staticRenderFns } from "./ProductViewSupplierProducts.vue?vue&type=template&id=c1a5a3fe"
import script from "./ProductViewSupplierProducts.vue?vue&type=script&lang=js"
export * from "./ProductViewSupplierProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports